<template>
  <dashboard-main-layout>
    <div class="fleet-page-wrapper">
      <!-- custom-selectors slot -->
      <appbar :showBorder="true" :dense="true">
        <template v-slot:custom-selectors>
          <div class="d-flex align-center" style="gap: 24px; height: 100%">
            <!-- Site Selector -->
            <div
              v-if="
                $route.name === 'dashboard-fleet' &&
                !evolution_fleet &&
                !alarmes_fleetandevolution_fleet
              "
              class="d-flex align-center"
            >
              <v-combobox
                color="orange"
                v-model="choosesitefleet"
                dense
                clearable
                outlined
                :label="$t('_selectionner_des_sites_')"
                :items="itemsWithSelectAllfleet"
                multiple
                auto-select-first="exact"
                class="fleet-combo"
                @blur="onfleetSelectorClose"
                @change="markManualClose"
              >
                <template v-slot:selection="{ item, index }">
                  <span v-if="index === 0">{{ choosesitefleet[0] }}</span>
                  <span v-if="index === 1"> , (+{{ total }} autres) </span>
                </template>
                <v-list-item slot="prepend-item" ripple @click="toggle">
                  <v-list-item-action>
                    <v-icon
                      :color="
                        choosesitefleet.length > 0 ? 'indigo darken-4' : ''
                      "
                    >
                      {{ icon }}
                    </v-icon>
                  </v-list-item-action>
                  <v-list-item-title>
                    {{ $t("_select_all_") }}
                  </v-list-item-title>
                </v-list-item>
                <v-divider slot="prepend-item" class="mt-2" />
              </v-combobox>
            </div>

            <!-- Loading -->
            <LoadingDialog v-if="loading" :is_loading="loading" />

            <!-- Date Picker -->
            <div
              v-if="
                $route.name === 'dashboard-fleet' &&
                !evolution_fleet &&
                (alarmes_fleet || alarmes_fleetandevolution_fleet)
              "
              class="date_selector"
            >
              <div class="d-flex align-center" style="gap: 10px">
                <div v-if="isWarningCondition" style="position: relative">
                  <v-icon
                    @click="showAlert = !showAlert"
                    :color="color_warning_msg"
                  >
                    mdi-alert
                  </v-icon>
                  <v-alert
                    v-model="showAlert"
                    v-show="showAlert"
                    type="info"
                    dense
                    shaped
                    dismissible
                    :color="color_warning_msg"
                    class="mt-2"
                    style="
                      position: absolute;
                      top: 20px;
                      left: 10px;
                      width: 400px;
                      z-index: 10;
                    "
                  >
                    {{ warning_error_msg }}
                  </v-alert>
                </div>

                <!-- Date selector -->
                <v-menu
                  ref="menu"
                  v-model="menu"
                  content-class="custom-datepicker-menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-combobox
                      v-model="dateRange"
                      prepend-icon="mdi-calendar"
                      :color="isDateModified ? 'orange' : 'grey darken-1'"
                      readonly
                      hide-details
                      v-bind="attrs"
                      class="fleet-date"
                      v-on="on"
                      @click="menu = true"
                      @click:prepend="
                        isDateModified ? resetToMaxDate() : (menu = true)
                      "
                    />
                  </template>

                  <v-date-picker
                    v-model="tempDate"
                    scrollable
                    :min="'2016-01-01'"
                    :max="maxDate"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text @click="menu = false">Annuler</v-btn>
                    <v-btn text color="primary" @click="refreshDates"
                      >Rafraichir</v-btn
                    >
                  </v-date-picker>
                </v-menu>
              </div>
            </div>
          </div>
        </template>
      </appbar>
      <div>
        <div style="display: flex">
          <dashboardfleet
            :liste_dashboard="list_dashboard"
            :alarmsByInstallation="alarmsByInstallation"
          />
          <v-card
            style="
              flex: 1;
              margin-top: 10px;
              margin-left: 5px;
              margin-right: 10px;
            "
          >
            <Mapfleet
              :selectsite="choosesitefleet"
              :liste_fleet="list_fleet.data"
            />
          </v-card>
        </div>
        <div>
          <v-card
            style="
              flex: 1;
              margin-top: 10px;
              margin-left: 10px;
              margin-right: 10px;
              border-top: 10px;
              border-bottom: 0px;
              padding: 10px;
            "
          >
            <div class="btn">
              <v-btn @click="setChangebuttonname(0)">{{
                $t("_evolutions_")
              }}</v-btn>
              <v-btn @click="setChangebuttonname(1)">{{
                $t("_evolutions_/_alarmes_")
              }}</v-btn>
              <v-btn
                @click="setChangebuttonname(2)"
                :color="changelable === '_exit_' ? 'orange' : undefined"
                >{{ $t(changelable) }}</v-btn
              >
            </div>
          </v-card>
          <div style="display: flex">
            <v-card
              v-if="
                evolution_fleet == true ||
                alarmes_fleetandevolution_fleet == true
              "
              :style="{
                marginRight: evolution_fleet == true ? '10px' : '0',
                marginLeft: '10px',
                backgroundColor: '#f5f5f5',
                border: '5px solid orange',
                borderRadius: '8px',
              }"
              style="flex: 1; margin-left: 10px; border-radius: 0"
            >
              <Evolutionfleet
                :selected_site_id="list_id"
                :change_size="alarmes_fleetandevolution_fleet"
              />
            </v-card>
            <v-card
              v-if="
                alarmes_fleet == true || alarmes_fleetandevolution_fleet == true
              "
              :style="{
                marginLeft: alarmes_fleet == true ? '10px' : '0',
                marginRight: '10px',
              }"
              style="flex: 1; margin-right: 10px; border-radius: 0"
            >
              <Alarmsfleet
                :liste_alarmes="list_alarms"
                :activeButton="this.activeButton"
              />
            </v-card>
          </div>
        </div>
        <div>
          <v-card
            style="
              margin-bottom: 10px;
              margin-left: 10px;
              margin-right: 10px;
              margin-top: -20px;
            "
          >
            <Installationsfleet
              :selectsite="choosesitefleet"
              :liste_fleet="list_fleet.data"
              :selected_date="dateRange"
            />
          </v-card>
        </div>
      </div>
    </div>
  </dashboard-main-layout>
</template>

<script>
import DashboardMainLayout from "../../../layouts/Dashboard/MainLayout";
import Appbar from "../../../components/App/Appbar.vue";
import { mapGetters } from "vuex";
import dashboardfleet from "./dashboardfleet.vue";
import Mapfleet from "./Mapfleet.vue";
import Installationsfleet from "./Installationsfleet";
import Alarmsfleet from "./Alarmsfleet";
import Evolutionfleet from "./Evolutionfleet";
import api from "@/api/api";
import LoadingDialog from "@/components/Utils/LoadingDialog";

export default {
  components: {
    DashboardMainLayout,
    Appbar,
    dashboardfleet,
    Mapfleet,
    Installationsfleet,
    Alarmsfleet,
    Evolutionfleet,
    LoadingDialog,
  },

  mounted() {
    this.setDefaultDateToYesterday();

    this.setChangebuttonname(2);
    if (!this.isDataFetched) {
      this.loadInstallationData().then(() => {});
    }

    this.$nextTick(async () => {
      await this.take_selected_id();
    });

    this.isDateModified = this.dateRange !== this.maxDate;
  },

  data() {
    return {
      loading: false,
      alarmes_fleet: false,
      evolution_fleet: false,
      total: 0,
      alarmes_fleetandevolution_fleet: true,
      activeButton: 0,
      menu: false,
      color_warning_msg: "",
      maxDate: new Date(Date.now() - 86400000).toISOString().substr(0, 10), // 86400000 ms = 1 day
      warning_error_msg: "",
      isDateModified: false,
      tempDate: null,
      showAlert: false,
      isManualClose: true,
      count: 0,
      list_names: [],
      changeprint: 1,
      list_fleet: [],
      nb_of_sites_sent: 0,
      list_id: [],
      compteur: 0,
      isDataFetched: false,
      defaultDashboard: {
        nb_de_site: 0,
        pr_clean_parc: 0,
        pr_clean_parc_evo: 0,
        ip_clean_parc: 0,
        ip_clean_parc_evo: 0,
        pc_totale: 0,
        disponibilite_parc: 0,
        disponibilite_parc_evo: "_ ",
        pertes_recouvrables: "_ ",
        pertes_vs_modele_energie: "_ ",
        pertes_vs_modele_energie_evo: "_ ",
        major_alarms: 0,
        minor_alarms: 0,
        without_alarms: 0,
      },
      list_dashboard: {
        nb_de_site: 0,
        pr_clean_parc: 0,
        pr_clean_parc_evo: 0,
        ip_clean_parc: 0,
        ip_clean_parc_evo: 0,
        pc_totale: 0,
        disponibilite_parc: 0,
        disponibilite_parc_evo: "_ ",
        pertes_recouvrables: "_ ",
        pertes_vs_modele_energie: "_ ",
        pertes_vs_modele_energie_evo: "_ ",
        major_alarms: 0,
        minor_alarms: 0,
        without_alarms: 0,
      },
      list_alarms: [],
      alarmsByInstallation: {
        major_alarms: 0,
        minor_alarms: 0,
        no_alarm_found: 0,
      },
    };
  },

  computed: {
    itemsWithSelectAllfleet() {
      return this.list_names;
    },
    ...mapGetters({
      cur_install_id: "cur_install_id",
      installations: "installations",
      role: "role",
    }),
    choosesAllfleet() {
      return (
        this.choosesitefleet.length ===
        (this.itemsWithSelectAllfleet || []).length
      );
    },
    parcDates() {
      return this.$store.state.parametersStore.dates;
    },

    choosesSomefleet() {
      return this.choosesitefleet.length > 0 && !this.choosesAllfleet;
    },
    dateRange: {
      get() {
        // Always return the string from Vuex, not the object
        return this.$store.getters.parcDates.start || "";
      },
      set(value) {
        // Update Vuex properly when date changes
        this.$store.commit("SET_PARC_DATES_START", value);
      },
    },

    icon() {
      if (this.choosesAllfleet) return "mdi-close-box";
      if (this.choosesSomefleet) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    changelable() {
      if (!this.evolution_fleet && !this.alarmes_fleetandevolution_fleet) {
        return "_alarmes_";
      } else if (
        !this.evolution_fleet ||
        !this.alarmes_fleetandevolution_fleet
      ) {
        return "_exit_";
      }
      return "_alarmes_";
    },
    isWarningCondition() {
      const result = Math.abs(
        this.nb_of_sites_sent - this.list_dashboard.nb_de_site
      );
      return result != 0 && this.dateRange === this.maxDate;
    },
    choosesitefleet: {
      get() {
        // Access namespaced getter
        return (
          this.$store.getters["selectedSitesStore/selectedSitesFleet"] || []
        );
      },
      set(val) {
        // Commit via namespaced mutation
        this.$store.commit("selectedSitesStore/SET_SELECTED_SITES_FLEET", val);
      },
    },
  },

  watch: {
    choosesitefleet(newchoosesitefleet) {
      localStorage.setItem(
        "choosesitefleet",
        JSON.stringify(newchoosesitefleet)
      );
      this.total = 0;
      this.total = this.choosesitefleet.length - 1;
      if (this.isManualClose) {
        this.take_selected_id(); // Make sure to call this when items are selected
      }
    },
    dateRange(newVal) {
      this.isDateModified = newVal !== this.maxDate;
      this.take_selected_id();
    },

    "$root.$i18n.locale": {
      async handler() {
        await this.take_selected_id();
        this.changelable;
      },
      immediate: true,
      deep: true,
    },
    $route: {
      async handler() {
        //this.refresHeader()
        await this.$nextTick();
        this.isDataFetched = false;
        await this.take_selected_id();
      },
      immediate: true,
    },

    async "$store.getters.parcCalendarRefresh"() {
      if (this.$store.getters.parcCalendarRefresh) {
        this.$store.commit("SET_PARC_CALENDAR_REFRESH", false);
        this.dateRange = this.$store.getters.parcDates.start;
      }
    },
  },

  methods: {
    setDefaultDateToYesterday() {
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      if (this.$store.getters.parcDates.start)
        this.dateRange = this.$store.getters.parcDates.start;
      else this.dateRange = yesterday.toISOString().slice(0, 10);
    },

    resetToMaxDate() {
      this.dateRange = this.maxDate;
      this.tempDate = this.maxDate;
      this.isDateModified = false;
      this.take_selected_id();
    },

    markManualClose() {
      this.isManualClose = false;
    },

    onfleetSelectorClose() {
      this.isManualClose = true;
      this.take_selected_id();
    },

    // takeitems only called once and data is cached
    async takeitems() {
      let list_names = [];
      this.list_id = [];

      let liste_2 = this.installations.map((e) => e.installation_id.toString());

      if (!liste_2.length) return []; // Guard clause for empty installations
      const current_role = ["admin", "data-analyst"];
      const hasPrivilegedRole = current_role.includes(this.role);
      try {
        const response = await api.getFleetInstallationList(liste_2);

        response.data.forEach((element) => {
          const site = this.installations.find(
            (site) => element.name.trim() === site.installation_name.trim()
          );
      
          if (site && (hasPrivilegedRole || element.is_visible)) {           
            list_names.push(site.installation_name.trim());
            this.list_id.push(site.installation_id.toString());
          }
        });

        return list_names; // Return the updated list of names
      } catch (error) {
        console.error("Error fetching fleet info:", error);
        return []; // Ensure something is returned even on error
      }
    },

    async toggle() {
      if (this.choosesitefleet.length === this.list_names.length) {
        this.choosesitefleet = [];
      } else {
        this.choosesitefleet = [...this.list_names];
      }
    },
    async loadInstallationData() {
      if (this.isDataFetched) return;

      // Load the fleet names
      this.list_names = await this.takeitems();

      // Restore from localStorage if present, otherwise select all
      const savedchoosesitefleet = JSON.parse(
        localStorage.getItem("choosesitefleet")
      );
      if (savedchoosesitefleet && savedchoosesitefleet.length > 0) {
        // Keep only valid names
        this.choosesitefleet = savedchoosesitefleet.filter((site) =>
          this.list_names.includes(site)
        );
      } else {
        this.choosesitefleet = [...this.list_names];
      }

      this.isDataFetched = true;

      // Update total counter
      this.total = this.choosesitefleet.length - 1;
    },

    async take_selected_id() {
      let elm = [];
      let site_names_sent = "";
      this.nb_of_sites_sent = 0;
      // Iterate through the selected items to map them to IDs
      this.choosesitefleet.forEach((site) => {
        this.installations.forEach((element) => {
          if (site === element.installation_name.trim()) {
            elm.push(element.installation_id);
          }
        });
      });

      // Now, update the list_id with the selected IDs
      // this.list_id = elm;

      // Proceed with further operations like loading fleet data
      await this.loadInstallationData();

      // Ensure list_fleet is updated with the correct data
      this.list_dashboard = { ...this.defaultDashboard };
      if (elm.length > 0) {
        try {
          this.nb_of_sites_sent = elm.length;

          if (this.compteur < 2) this.compteur = 2;
          const response = await api.getlistfleet({
            fleet: elm,
            dates: this.dateRange,
            country_lang_code: this.$root.$i18n.locale,
          });
          if (Array.isArray(response.data)) {
            // normalize array response
            this.list_fleet = { data: response.data, total: {} };
          } else {
            this.list_fleet = response.data;
          }
          this.list_dashboard = response.data.total
            ? { ...response.data.total }
            : { ...this.defaultDashboard };
        } catch (error) {
          console.error("Error fetching getlistfleet:", error);
          this.list_fleet = [];
        }
      }

      if (elm.length > 0) {
        try {
          const response_alarm = await api.getlistalarms({
            alarms: elm,
            dates: this.dateRange,
            country_lang_code: this.$root.$i18n.locale,
          });
          this.list_alarms = response_alarm.data || [];
        } catch (error) {
          console.error("Error fetching getlistalarms:", error);
          this.list_alarms = [];
        }

        this.alarmsByInstallation = {
          major_alarms: 0,
          minor_alarms: 0,
          no_alarm_found: 0,
        };
        let installationResults = {};

        const alarmedInstallationIds = new Set(); // to track which installations have alarms

        // 1st pass: count major alarms (critique)
        this.list_alarms.forEach((alarm) => {
          const installationId = alarm.installation_id;
          alarmedInstallationIds.add(installationId);

          if (!installationResults[installationId]) {
            installationResults[installationId] = { severe: 0, critique: 0 };
          }

          if (
            alarm.criticity_info === "_critique_" &&
            installationResults[installationId].critique !== 1
          ) {
            installationResults[installationId].critique = 1;
            this.alarmsByInstallation.major_alarms += 1;
          }
        });

        // 2nd pass: count minor alarms (severe) only if no critique
        this.list_alarms.forEach((alarm) => {
          const installationId = alarm.installation_id;

          if (installationResults[installationId].critique === 1) return;

          if (
            alarm.criticity_info === "_severe_" &&
            installationResults[installationId].severe !== 1
          ) {
            installationResults[installationId].severe = 1;
            this.alarmsByInstallation.minor_alarms += 1;
          }
        });

        // 3rd pass: installations with alarms but no critique or severe
        Object.keys(installationResults).forEach((id) => {
          const { critique, severe } = installationResults[id];
          if (critique === 0 && severe === 0) {
            this.alarmsByInstallation.no_alarm_found += 1;
          }
        });

        // 4th pass: count installations in fleet that do NOT have any alarms in installationResults
        if (this.list_fleet.data) {
          this.list_fleet.data.forEach((fleetItem) => {
            const installationId = fleetItem.installation_id;
            if (!installationResults.hasOwnProperty(installationId)) {
              this.alarmsByInstallation.no_alarm_found += 1;
            }
            let severeCount = 0;
            let criticCount = 0;
            this.list_alarms.forEach((alarm) => {
              if (alarm.installation_id == installationId) {
                if (alarm.criticity_info === "_critique_") {
                  criticCount += 1;
                }
                if (alarm.criticity_info === "_severe_") {
                  severeCount += 1;
                }
              }
            });
            fleetItem.severe = severeCount;
            fleetItem.critic = criticCount;
          });
        }
      }

      const result = Math.abs(
        this.nb_of_sites_sent - this.list_dashboard.nb_de_site
      );
      const fleetData = Array.isArray(this.list_fleet?.data)
        ? this.list_fleet.data
        : [];
      const receivedIds = fleetData.map((i) => i.installation_id);
      const missingIds = elm.filter(
        (id) => !receivedIds.includes(parseInt(id, 10))
      );

      const missingNames = missingIds
        .map((id) => {
          const s = this.installations.find(
            (inst) => inst.installation_id === id
          );
          return s ? s.installation_name.trim() : null;
        })
        .filter(Boolean); // remove nulls

      site_names_sent = missingNames.join(",\n");
      // Get current hour now
      const currentHour = new Date().getHours();

      if (this.dateRange === this.maxDate && result != 0) {
        if (currentHour >= 0 && currentHour <= 7) {
          // case when installations > 5 → show difference in numbers
          this.color_warning_msg = "orange";
          this.warning_error_msg = `Données en cours d’acquisition`;
          this.showAlert = true;
        } else if (currentHour >= 8) {
          if (result > 5) {
            this.color_warning_msg = "#ff0000";
            this.warning_error_msg = `Données manquantes pour ${result} sites `;
            this.showAlert = true;
          } else {
            this.color_warning_msg = "#ff0000";
            this.warning_error_msg = `Données manquantes pour ${site_names_sent} `;
            this.showAlert = true;
          }
        }
      }
      this.compteur++;
      this.loading = false;
    },

    setChangebuttonname(value) {
      this.activeButton = value; // Update the active button state
      if (value === 0) {
        this.alarmes_fleet = false;
        this.evolution_fleet = true;
        this.alarmes_fleetandevolution_fleet = false;
      } else if (value === 1) {
        this.evolution_fleet = false;
        this.alarmes_fleetandevolution_fleet = true;
        this.alarmes_fleet = false;
      } else if (value === 2) {
        this.alarmes_fleet = true;
        this.evolution_fleet = false;
        this.alarmes_fleetandevolution_fleet = false;
      }
    },

    refreshDates() {
      if (this.tempDate) {
        // If tempDate is already a string in YYYY-MM-DD format
        this.dateRange = this.tempDate;
      }
      this.menu = false;
    },
  },
};
</script>

<style scoped>
/* --- LAYOUT & MARGINS (Keep these as they are) --- */
.btn {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 50px;
}

.date_selector {
  width: 200px;
  margin-left: 50px;
  margin-right: 0px;
}
.v-menu__content {
  min-width: 290px !important;
}

::v-deep .v-main {
  padding-top: 64px !important;
  padding-left: 256px !important;
  background-color: #f5f5f5 !important;
}

/* --- THE FIX: KILL THE TRANSPARENT SPACE --- */
/* This specifically targets your fleet inputs to undo the intern's 'fit-content' leak */
.fleet-combo .v-input__slot,
.fleet-date .v-input__slot {
  min-height: 40px !important; /* Force standard Vuetify height */
  height: 40px !important;
  display: flex !important;
  align-items: center !important;
  padding: 0 12px !important;
}

/* Remove the extra space usually reserved for hints/errors */
::v-deep .fleet-combo .v-text-field__details,
::v-deep .fleet-date .v-text-field__details {
  display: none !important;
  margin: 0 !important;
  padding: 0 !important;
  min-height: 0 !important;
}

/* --- TABLE STYLING (Wrapped in deep to work with scoped) --- */
::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr {
  background-color: rgb(214, 214, 214);
  border-radius: 5px;
}

::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th {
  color: #504f4f;
  padding-top: 10px;
  padding-bottom: 10px;
}

/* --- SELECTORS & RESPONSIVE --- */
.fleet-combo {
  width: 450px;
}

/* Target the appbar content specifically to avoid affecting the whole page */
::v-deep .v-toolbar__content {
  padding-top: 4px !important;
  padding-bottom: 4px !important;
}

/* --- DATE PICKER UI --- */
::v-deep .custom-datepicker-menu {
  box-shadow: none !important;
  border-radius: 4px;
  overflow: hidden;
}

::v-deep .v-picker--date {
  box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.2) !important;
}

/* Tablet */
@media (max-width: 992px) {
  .fleet-combo {
    width: 300px !important;
  }
  .fleet-date {
    width: 200px !important;
  }
}

/* Mobile */
@media (max-width: 600px) {
  .fleet-combo,
  .fleet-date {
    width: 100% !important;
    min-width: 0 !important;
  }
}
</style>
<style>
/* Target the ID directly to increase priority */
#content.v-main {
  padding-top: 64px !important;
}
</style>
